<template>
  <div class="app">
    <!-- <div class="fade" v-if="this.active==2">

    </div> -->
    <div class="mui-card">
      <div class="mui-card-footer rejectionRemarkArea" v-if="rejectionRemark">
        <span class="mui-card-footer-left" style="flex-shrink: 0"
          >驳回备注：</span
        >
        <span style="color: red">{{ rejectionRemark }}</span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 35%"
          >所在建筑名称：</span
        >
        <span>{{ name }}</span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 35%">所在位置：</span>
        <div class="mui-card-footer-right" style="width: 45%">
          <input
            style="margin-bottom: 0"
            v-model="locationRemark"
            :disabled="active == 2"
            name="exitBlindFlag"
            value="1"
            class="input-text"
            type="text"
            placeholder="请输入位置描述"
          />
        </div>
      </div>
      <div class="mui-card-footer" style="border-bottom: 1px solid #ccc">
        <span class="mui-card-footer-left">设施评价：</span>
        <span style="margin-right: 16px">
          <Rate
            :score="score"
            :readonly="active == 2"
            v-on:getScore="getScore"
          ></Rate>
        </span>
      </div>
      <div class="mui-card">
        <span
          style="
            color: rgb(109, 109, 114);
            line-height: 28px;
            display: inline-block;
            width: 100%;
            padding-left: 5px;
          "
          >设施情况</span
        >
        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">是否为无障碍厕所：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.isaccess"
                  name="iaaccess"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />是</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.isaccess"
                  name="iaaccess"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />否</span
              >
            </div>
          </div>

          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">第三卫生间：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.aloneFlag"
                  name="aloneFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />是</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.aloneFlag"
                  name="aloneFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />否</span
              >
            </div>
          </div>

          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">门开启方式：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.openDoorType"
                  name="openDoorType"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />电动</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.openDoorType"
                  name="openDoorType"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />手动</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">门开启朝向：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio" style="margin: 0 10px"
                ><input
                  v-model="formItem.moveDoorType"
                  name="moveDoorType"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />平移</span
              >
              <span class="span-input-radio" style="margin: 0 10px"
                ><input
                  v-model="formItem.moveDoorType"
                  name="moveDoorType"
                  value="2"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />向内</span
              >
              <span class="span-input-radio" style="margin: 0 10px"
                ><input
                  v-model="formItem.moveDoorType"
                  name="moveDoorType"
                  value="3"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />向外</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.openDoorType - 0">
            <span class="mui-card-footer-left">外侧横扶把手：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.outsideHandFlag"
                  name="outsideHandFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.outsideHandFlag"
                  name="outsideHandFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.openDoorType - 0">
            <span class="mui-card-footer-left">内侧横扶把手：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.insideHandFlag"
                  name="insideHandFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.insideHandFlag"
                  name="insideHandFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">小便器：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.urineFlag"
                  name="urineFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.urineFlag"
                  name="urineFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.urineFlag - 0">
            <span class="mui-card-footer-left">小便器垂直抓杆：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.unineVerticalFlag"
                  name="unineVerticalFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.unineVerticalFlag"
                  name="unineVerticalFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.urineFlag - 0">
            <span class="mui-card-footer-left">小便器水平抓杆：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.unineLevelFlag"
                  name="unineLevelFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.unineLevelFlag"
                  name="unineLevelFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">坐便器：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.siteShitFlag"
                  name="siteShitFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.siteShitFlag"
                  name="siteShitFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.siteShitFlag - 0">
            <span class="mui-card-footer-left">坐便垂直抓杆：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.siteShitVerticalFlag"
                  name="siteShitVerticalFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.siteShitVerticalFlag"
                  name="siteShitVerticalFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.siteShitFlag - 0">
            <span class="mui-card-footer-left">坐便水平抓杆：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.siteShitLevelFlag"
                  name="siteShitLevelFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.siteShitLevelFlag"
                  name="siteShitLevelFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">洗手盆镜子：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.washBasinMirrorFlag"
                  name="washBasinMirrorFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.washBasinMirrorFlag"
                  name="washBasinMirrorFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">无障碍标志：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.freeBarrierSignFlag"
                  name="freeBarrierSignFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.freeBarrierSignFlag"
                  name="freeBarrierSignFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">救助呼叫按钮：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.callFlag"
                  name="callFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.callFlag"
                  name="callFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">取纸器：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.getPageFlag"
                  name="getPageFlag"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.getPageFlag"
                  name="getPageFlag"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
        </div>
        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">门宽度：</span>
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.widthDoorValue"
              />cm
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.outsideHandFlag - 0">
            <span class="mui-card-footer-left" style="width: 50%"
              >门外侧横扶手高度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.outsideHandValue"
              />cm
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.insideHandFlag - 0">
            <span class="mui-card-footer-left" style="width: 50%"
              >门内侧横扶手高度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.insideHandValue"
              />cm
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.urineFlag - 0">
            <span class="mui-card-footer-left" style="width: 35%"
              >小便器下口高：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.unineHeightValue"
              />cm
            </div>
          </div>
          <div
            class="mui-card-footer-div"
            v-if="formItem.siteShitLevelFlag - 0"
          >
            <span class="mui-card-footer-left" style="width: 50%"
              >坐便水平抓杆长度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.siteShitVerticalValue"
              />cm
            </div>
          </div>
          <div
            class="mui-card-footer-div"
            v-if="formItem.siteShitLevelFlag - 0"
          >
            <span class="mui-card-footer-left" style="width: 52%"
              >坐便水平抓杆离地高度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.siteShitVerticalOffValue"
              />cm
            </div>
          </div>
          <div
            class="mui-card-footer-div"
            v-if="formItem.siteShitVerticalFlag - 0"
          >
            <span class="mui-card-footer-left" style="width: 52%"
              >坐便垂直抓杆长度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.siteShitLevelValue"
              />cm
            </div>
          </div>
          <!--          <div class="mui-card-footer-div">-->
          <!--            <span class="mui-card-footer-left" style="width: 52%">洗手盆下方宽度：</span>-->
          <!--            <div class="mui-numbox mui-card-footer-right">-->
          <!--              <input class="mui-input-numbox" type="number" v-model="formItem.washBasinWidthValue"/> cm-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left" style="width: 52%"
              >洗手盆下方高度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.washBasinHeightValue"
              />cm
            </div>
          </div>
          <!--          <div class="mui-card-footer-div">-->
          <!--            <span class="mui-card-footer-left" style="width: 52%">洗手盆下方深度：</span>-->
          <!--            <div class="mui-numbox mui-card-footer-right">-->
          <!--              <input class="mui-input-numbox" type="number" v-model="formItem.siteShitDeepValue"/> cm-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="mui-card-footer-div" v-if="formItem.callFlag - 0">
            <span class="mui-card-footer-left" style="width: 52%"
              >救助呼叫按钮高度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.callHeightValue"
              />cm
            </div>
          </div>
          <div class="mui-card-footer-div" v-if="formItem.getPageFlag - 0">
            <span class="mui-card-footer-left" style="width: 52%"
              >取纸器离地高度：</span
            >
            <div class="mui-numbox mui-card-footer-right">
              <input
                :disabled="active == 2"
                class="mui-input-numbox"
                type="number"
                v-model="formItem.getPageHeightValue"
              />cm
            </div>
          </div>
        </div>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left">设施图片：</span>
        <div class="img-files flex">
          <div v-if="imgs.length > 0" class="flex">
            <div class="img-box" v-for="(item, i) in imgs" :key="i">
              <img :src="item" alt="" v-image-preview />
              <span @click="del(i)" v-if="active != 2"
                ><i class="mui-icon mui-icon-close"></i
              ></span>
            </div>
          </div>
          <div class="img-file" v-if="imgs.length < size">
            <input
              type="file"
              id="files"
              accept="image/*"
              ref="updateFiles"
              @change="fileChange"
            />
          </div>
        </div>
        <span class="img-add-class" v-if="active != 2">
          <span class="mui-icon mui-icon-plus" @click="clickUpdateImage"></span>
        </span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 55%">设施描述：</span>
        <span v-if="active != 2">
          <textarea
            name=""
            cols="30"
            rows="10"
            v-model="textAreaValue"
            style="margin-bottom: 0"
          ></textarea>
          <span class="mui-badge" @click="addComment('非常方便')" ref="comment1"
            >非常方便</span
          >
          <span
            class="mui-badge"
            @click="addComment('完全无障碍')"
            ref="comment2"
            >完全无障碍</span
          >
          <span
            class="mui-badge"
            @click="addComment('设施完好，赞！')"
            ref="comment3"
            >设施完好，赞！</span
          >
          <span
            class="mui-badge"
            @click="addComment('设施不可用')"
            ref="comment3"
            >设施不可用</span
          >
        </span>
        <span v-else>
          <textarea
            name=""
            :disabled="active == 2"
            cols="30"
            rows="10"
            v-model="textAreaValue"
            style="margin-bottom: 0"
          ></textarea>
        </span>
      </div>
    </div>
    <div
      class="mui-card"
      v-if="this.active === '1' || this.active === '3'"
      style="text-align: center"
    >
      <mt-button type="primary" @click="clickSubmit">上传</mt-button>
    </div>
    <div class="mui-card" v-if="showReEditBtn">
      <mt-button type="primary" @click="reEdit">重新编辑</mt-button>
    </div>
  </div>
</template>

<script>
import Rate from "../common/Rate";
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import { compressImage,compressImageWithout } from '../../utils/compressImage';
import {getUserLocation,configureWechatSDK} from '../../utils/wechatSDK';
import {generateRandomFileName,ossClient} from "../../utils/oss_config"
export default {
  name: "toliet",
  data() {
    return {
      textAreaValue: "",
      formItem: {
        widthDoorValue: "0",
        outsideHandValue: "0",
        insideHandValue: "0",
        unineHeightValue: "0",
        siteShitVerticalValue: "0",
        siteShitVerticalOffValue: "0",
        siteShitLevelValue: "0",
        // washBasinWidthValue: '0',
        washBasinHeightValue: "0",
        // siteShitDeepValue: '0',
        callHeightValue: "0",
        getPageHeightValue: "0",
        openDoorType: 1,
        moveDoorType: 1,
        outsideHandFlag: 0,
        insideHandFlag: 0,
        aloneFlag: 0,
        urineFlag: 0,
        unineVerticalFlag: 0,
        unineLevelFlag: 0,
        siteShitFlag: 0,
        siteShitVerticalFlag: 0,
        siteShitLevelFlag: 0,
        washBasinMirrorFlag: 0,
        freeBarrierSignFlag: 0,
        callFlag: 0,
        getPageFlag: 0,
        isaccess: 1,
      },
      locationRemark: "",
      returnImgs: [],
      score: null,
      imgs: [],
      imgfiles: [],
      size: 5,
      title: "无障碍厕所",
      active:
        this.$route.params.active == "20" ? "2" : this.$route.params.active,
      showReEditBtn: this.$route.params.active == "20" ? true : false, //当是自己的上报记录且审核状态为待审核或审核驳回时，显示重新编辑按钮，点击后切换为编辑模式
      task_id: this.$route.params.taskId,
      building_id: this.$route.params.buildingId,
      buildingdevicetype_id: this.$route.params.facilitiesTypeId,
      id: this.$route.params.id,
      host: process.env.BASE_URL,
      name: "",
      savedata: {},
      currentPosi: [], //当前位置坐标
      rejectionRemark: "", //驳回备注
    };
  },
  created() {
    this.$emit("getTitle", this.title);
    this.getChildBuildingInfo();
    this.initMsg();

    var that = this;
    var getCurrentLocationInterval = setInterval(function () {
      that.getData(that, that.currentPosi, function () {
        clearInterval(getCurrentLocationInterval);
      });
    }, 1000);
    //销毁定时器
    this.$once("hook:beforeDestroy", () => {
      clearInterval(getCurrentLocationInterval);
    });
  },
  methods: {
    submitImageWithOss(imgId,fileExtension){
      Indicator.open("上传中...");
      
      const file = this.imgfiles[imgId].get('file');
      const fileName = generateRandomFileName(fileExtension); // 自定义文件名

      ossClient.put(fileName, file).then(result => {
        // 上传成功
        const imageUrl = result.url; // 上传成功后返回的图片URL
        this.returnImgs.push(imageUrl);
        Indicator.close();
        Toast("上传成功")
      }).catch(error => {
        // 上传失败
        console.error('Failed to upload the image:', error);
      });

    },
    insertdata() {
      let savedata = localStorage.getItem(
        this.building_id + "," + this.buildingdevicetype_id
      );
      if (savedata === null || savedata === undefined || savedata === "") {
        return;
      } else {
        Toast("已自动导入上一次数据");
      }

      //      自己导入存储数据
      let savedataobj = JSON.parse(savedata);

      if (savedataobj.formItem) {
        this.formItem = savedataobj.formItem;
      }
      // if (savedataobj.locationRemark) {
      //   this.locationRemark = savedataobj.locationRemark
      // }
      if (savedataobj.score) {
        this.score = savedataobj.score;
      }
      if (savedataobj.textAreaValue) {
        this.textAreaValue = savedataobj.textAreaValue;
      }
    },
    clickUpdateImage() {
      this.$refs.updateFiles.click();
    },
    mounted() {
      this.initMsg();
    },
     fileChange() {
      var _this = this
      var event = window.event
      var file = event.target.files
      var reader = new FileReader()
      let formData = new FormData()
      const fileName = file[0].name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
      compressImageWithout(file[0], 800000, 6000000, 0.4).then((res) => {
        // console.log('压缩之后图片尺寸大小: ', res.size / 1024)
        // console.log('实际压缩率： ', ((file[0].size - res.size) / file[0].size * 100).toFixed(2) + '%');
        formData.append('file', new File([res], 'my-image1.png', { type: 'image/png' }))
        _this.imgfiles.push(formData)
        reader.readAsDataURL(new File([res], 'my-image1.png', { type: 'image/png' }))
        reader.onload = function (e) {
          _this.imgs.push(e.target.result)
        }
        // _this.submitImage(0)
        _this.submitImageWithOss(0,fileExtension)
        this.imgfiles.splice(0, 1)
      })

    },
    del(i) {
      this.imgs.splice(i, 1);
      this.returnImgs.splice(i, 1);
    },
    addComment(val) {
      if (this.textAreaValue === "") {
        this.textAreaValue = this.textAreaValue + val;
      } else {
        this.textAreaValue = this.textAreaValue + "," + val;
      }
    },
    reEdit() {
      this.active = "3";
      this.showReEditBtn = false;
    },
    clickSubmit() {
      if (this.locationRemark === "") {
        Toast("请输入位置信息");
        return false;
      }
      if (this.returnImgs.length == 0) {
        Toast("请上传设施图片");
        return false;
      }
      this.submitpostdata();
    },
    submitImage(imgId) {
      Indicator.open("上传中...");
      this.$http
        .post("api/gather/uplaodimg", this.imgfiles[imgId], {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (data) {
          Indicator.close();
          if (data.body.code === 1) {
            this.returnImgs.push(data.body.data.url);
          }
        })
        .catch((error) => {
          Indicator.close();
          Toast("网络错误！");
        });
    },
    submitpostdata() {
      Indicator.open("提交中...");
      if (this.active === "1") {
        this.$http
          .post(
            "api/gather/submitpostdata",
            {
              task_id: this.task_id,
              building_id: this.building_id,
              buildingdevicetype_id: this.buildingdevicetype_id,
              score: this.score,
              positiondesc: this.locationRemark,
              devicedesc: this.formItem,
              desc: this.textAreaValue,
              images: this.returnImgs.join(","),
              position: this.currentPosi,
            },
            { emulateJSON: true }
          )
          .then(function (data) {
            if (data.body.code === 1) {
              Indicator.close();
              Toast("上传成功");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            } else {
              Toast(data.body.msg);
            }
          })
          .catch((error) => {
            Indicator.close();
            Toast("网络错误！");
          });
      } else {
        this.$http
          .post(
            "api/gather/editpostdata",
            {
              id: this.id,
              task_id: this.task_id,
              building_id: this.building_id,
              buildingdevicetype_id: this.buildingdevicetype_id,
              score: this.score,
              positiondesc: this.locationRemark,
              devicedesc: this.formItem,
              desc: this.textAreaValue,
              images: this.returnImgs.join(","),
            },
            { emulateJSON: true }
          )
          .then(function (data) {
            if (data.body.code === 1) {
              Indicator.close();
              Toast("上传成功");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            } else {
              Toast(data.body.msg);
            }
          })
          .catch((error) => {
            Indicator.close();
            Toast("网络错误！");
          });
      }
    },
    getScore(score) {
      this.score = score;
    },
    initMsg() {
      if (this.active === "2" || this.active === "3") {
        this.$http
          .get("api/gather/checkPostInfo?id=" + this.id)
          .then(function (data) {
            if (data.body.code === 1) {
              data = data.body.data.info;
              data.devicedesc = JSON.parse(data.devicedesc);
              let Imgs = [];
              if (data.images) {
                Imgs = data.images.split(",");
              }
              this.rejectionRemark = data.remark;
              this.textAreaValue = data.desc;
              // this.formItem.widthDoorValue = data.devicedesc.widthDoorValue
              // this.formItem.outsideHandValue = data.devicedesc.outsideHandValue
              // this.formItem.insideHandValue = data.devicedesc.insideHandValue
              // this.formItem.unineHeightValue = data.devicedesc.unineHeightValue
              // this.formItem.siteShitVerticalValue = data.devicedesc.siteShitVerticalValue
              // this.formItem.siteShitVerticalOffValue = data.devicedesc.siteShitVerticalOffValue
              // this.formItem.siteShitLevelValue = data.devicedesc.siteShitLevelValue
              // // this.formItem.washBasinWidthValue = data.devicedesc.washBasinWidthValue
              // this.formItem.washBasinHeightValue = data.devicedesc.washBasinHeightValue
              // // this.formItem.siteShitDeepValue = data.devicedesc.siteShitDeepValue
              // this.formItem.callHeightValue = data.devicedesc.callHeightValue
              // this.formItem.getPageHeightValue = data.devicedesc.getPageHeightValue
              // this.formItem.openDoorType = data.devicedesc.openDoorType
              // this.formItem.moveDoorType = data.devicedesc.moveDoorType
              // this.formItem.outsideHandFlag = data.devicedesc.outsideHandFlag
              // this.formItem.insideHandFlag = data.devicedesc.insideHandFlag
              // this.formItem.aloneFlag = data.devicedesc.aloneFlag
              // this.formItem.urineFlag = data.devicedesc.urineFlag
              // this.formItem.unineVerticalFlag = data.devicedesc.unineVerticalFlag
              // this.formItem.unineLevelFlag = data.devicedesc.unineLevelFlag
              // this.formItem.siteShitFlag = data.devicedesc.siteShitFlag
              // this.formItem.siteShitVerticalFlag = data.devicedesc.siteShitVerticalFlag
              // this.formItem.siteShitLevelFlag = data.devicedesc.siteShitLevelFlag
              // this.formItem.washBasinMirrorFlag = data.devicedesc.washBasinMirrorFlag
              // this.formItem.freeBarrierSignFlag = data.devicedesc.freeBarrierSignFlag
              // this.formItem.callFlag = data.devicedesc.callFlag
              // this.formItem.getPageFlag = data.devicedesc.getPageFlag
              this.formItem = data.devicedesc;
              this.score = data.score;
              this.locationRemark = data.positiondesc;
              for (let i = 0; i < Imgs.length; i++) {
                this.imgs[i] = this.host + Imgs[i];
                this.returnImgs[i] = Imgs[i];
              }
            } else {
              Toast(data.body.data.msg);
            }
          })
          .catch((error) => {
            Indicator.close();
            Toast("网络错误！");
          });
      } else {
        this.insertdata();
      }
    },
    getChildBuildingInfo() {
      this.$http
        .get("api/gather/getChildBuildingInfo?id=" + this.building_id)
        .then(function (data) {
          if (data.body.code === 1) {
            this.name = data.body.data.list.building.name;
          }
        })
        .catch((error) => {
          Indicator.close();
          Toast("网络错误！");
        });
    },
  },
  components: {
    Rate: Rate,
  },
  watch: {
    formItem: {
      handler(newValue, oldValue) {
        this.savedata.formItem = newValue;
        localStorage.setItem(
          this.building_id + "," + this.buildingdevicetype_id,
          JSON.stringify(this.savedata)
        );
      },
      deep: true,
    },
    locationRemark: function (newValue) {
      // console.log("ok")
      this.savedata.locationRemark = newValue;
      localStorage.setItem(
        this.building_id + "," + this.buildingdevicetype_id,
        JSON.stringify(this.savedata)
      );
    },
    score(newValue) {
      this.savedata.score = newValue;
      localStorage.setItem(
        this.building_id + "," + this.buildingdevicetype_id,
        JSON.stringify(this.savedata)
      );
    },
    textAreaValue(newValue) {
      this.savedata.textAreaValue = newValue;
      localStorage.setItem(
        this.building_id + "," + this.buildingdevicetype_id,
        JSON.stringify(this.savedata)
      );
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.app {
  margin-bottom: 15px;
}

.img-files {
  width: 70%;
  float: right;
  .flex {
    width: 85%;
    display: inline-block;
  }
  .img-box {
    width: 60px;
    height: 60px;
    position: relative;
    border: 1px solid #e6e6e6;
    margin-right: 10px;
    background-color: white;
    float: left;
    text-align: center;
    img {
      max-width: 60px;
      max-height: 60px;
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    span {
      position: absolute;
      top: -10px;
      left: 48px;
      color: red;
      display: block;
    }
    &:hover span {
      display: block;
    }
  }
  .img-add-class {
    width: 10%;
  }
}

.img-file {
  display: NONE;
  align-items: center;
  > input {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  > label {
    position: absolute;
    font-size: 14px;
    color: #333;
  }
}

.mui-card {
  margin-top: 15px;
  button {
    width: 100%;
  }
}

.mui-card-header {
  font-size: 15px;
}

select {
  margin: 0px;
  padding: 0px;
  background-color: #efefef;
  text-align: center;
}

.mui-card-footer-left {
  // width: 35%;
  display: inline-block;
  line-height: 28px;
}

.card {
  border-top: 1px solid #ccc;
  color: #6d6d72;
  padding: 10px 15px;
  .mui-card-footer-div {
    width: 100%;
    display: block;
    padding: 2px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .mui-card-footer-left {
      // width: 35%;
      display: inline-block;
      line-height: 28px;
    }
    .mui-card-footer-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      // float: right;
      // width: 130px;
      padding: 0;
      .mui-input-numbox {
        padding: 0;
        // width: 100px
      }
      .span-input-radio {
        // width: 45%;
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 28px;
        margin: 0 30px;
      }
    }
  }
}
.fade {
  width: 100vw;
  height: calc(100vh - 100px);
  position: fixed;
  //background: red;
  //background: none;
  z-index: 1000;
}
.rejectionRemarkArea {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Facilities/toilet.vue